import Phaser from 'phaser'
// import Button from '../ui/button'

export default class EditorHudScene extends Phaser.Scene {
  create () {
    this.cursorTxt = this.add.text(1100, 650, 'cursor pos')
    this.mainCam = this.scene.manager.getScene('GameScene').cameras.main
    this.game = this.scene.manager.getScene('GameScene')
  }

  update (time, delta) {
    // try {
    // var p = this.mainCam.getWorldPoint(this.input.activePointer.x, this.input.activePointer.y)
    // var posX = Math.ceil(p.x / 10) * 10
    // var posY = Math.ceil(p.y / 10) * 10

    var posX = this.game.levelEditor.image.x
    var posY = this.game.levelEditor.image.y

    // console.log(posX)

    this.cursorTxt.text = '' + posX.toFixed() + ', ' + posY.toFixed()
    // } catch (e) {
    // ignore..
    // this.cursorTxt.text = '?'
    // }
  }
}
